import { memo, useCallback, useEffect, useState } from "react"
import { getAuthors } from "../../services/AuthorService"
import AuthorSidebarCard from "./AuthorSidebarCard"
import { Link } from "react-router-dom"
import { Skeleton } from "antd"

const nrOfAuthors = 10

const AuthorsSidebar = memo(function AuthorsSidebar() {
    const [authors, setAuthors] = useState([])
    const [loading, setLoading] = useState(true)

    const getRandomAuthors = useCallback((page, limit) => {
        getAuthors(page, limit)
        .then(data => {
            setAuthors(data.content)
            setLoading(false)
        })
        .catch(err => {
            setAuthors([])
            setLoading(false)
        }) // no error displayed because this is just a sidebar
    }, [setAuthors, setLoading])

    useEffect(() => {
        getRandomAuthors(0, nrOfAuthors)
    }, [getRandomAuthors])

    return (
        <div className="flex-container flex-column white-color-background padding-5p border-radius-10 light-shaddow authors-sidebar">
            <div className="flex-container space-between">
                <h2 className="font-weight-400">Autori</h2>
                <Link to={'/autori'} className="no-text-decoration">
                    <p className="small-text text-black">Vidi sve</p>
                </Link>
            </div>
            {authors && authors.length !== 0 && !loading ? 
                authors.map(author => (
                    <Link to={'/autori/' + encodeURIComponent(author.url)} className="no-text-decoration" key={author.id}>
                        <AuthorSidebarCard 
                            firstName={author.firstName}
                            lastName={author.lastName}
                        />
                    </Link>
                ))
                :
                <div className="authors-skeleton-wrapper">
                    {[...Array(nrOfAuthors)].map((e, i) => (
                        <div key={i} style={{ height: '40px', display: 'flex', alignItems: 'center' }}> 
                            <Skeleton avatar active paragraph={{ rows: 0 }} title={{ width: '80%' }} />
                        </div>
                    ))}
                </div>
            }
        </div>
    )
})

export default AuthorsSidebar